import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';

import { ApiService, HttpMethod } from '../common/api.service';
import { ApiUrlService } from '../common/api-url.service';
import { MyApp } from '../common/enumerations';
import { ItemsCollection } from '../common/items-collection.model';
import { OrganizationListItem } from './organization-list-Item.model';
import { Organization } from './organization.model';

@Injectable({
    providedIn: 'root'
})
export class OrganizationApiService
{
    protected apiService: ApiService;

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService)
    {
        this.apiService = new ApiService(http);
    }

    getOrganizations(sortField?: string, sortOrder?: MyApp.SortOrder, pageIndex = 0, pageSize = ApiService.defaultPageSize): Observable<ItemsCollection<OrganizationListItem>>
    {
        return this.apiService.apiRequest(this.apiUrlService.getOrganizationsUrl(sortField, sortOrder, pageIndex, pageSize), HttpMethod.Get)
            .pipe(
                map((organizationsCollection: any) =>
                {
                    const organizationItems: OrganizationListItem[] = [];

                    organizationsCollection.Organizations.forEach(item =>
                    {
                        organizationItems.push(new OrganizationListItem(item));
                    });

                    return new ItemsCollection<OrganizationListItem>(organizationsCollection.Count, organizationItems);
                })
            );

    }

    getCurrentOrganization()
    {
        return this.apiService.apiRequest(this.apiUrlService.currentOrganizationUrl(), HttpMethod.Get)
            .pipe(
                map((organization: Organization) => new Organization(organization))
            );
    }

    getCurrentOrganizationImages()
    {
        return this.apiService.apiRequest(this.apiUrlService.currentOrganizationImagesUrl(), HttpMethod.Get);
    }
}
